import useSWR from "swr";
import { useRef, useState } from "react";
import { getCookie } from "cookies-next";
import ArrowIcon from "../icons/ArrowIcon";
import { getDeliveryDetails } from "@/services/product";
import useOnClickOutside from "@/hooks/useOnClickOutside";

const DeliveryInformations = ({ locale }) => {
  const regionId =
    getCookie("region_id") &&
    getCookie("region_id") != "NaN" &&
    getCookie("region_id") != "undefined"
      ? getCookie("region_id")
      : "1101";
  const ref = useRef();
  const [open, setOpen] = useState(false);
  useOnClickOutside([ref], () => setOpen(false));
  const [state, setState] = useState({
    insideRiyadh: regionId === "1101",
    delivery: [],
  });
  useSWR(`pdp-delivery-details`, async () => await getDeliveryDetails(), {
    revalidateOnFocus: false,
    onSuccess: ({ data }) => {
      setState((prev) => ({
        ...prev,
        delivery: data?.data?.active_details || [],
      }));
    },
  });
  return (
    <div className="my-3 bg-white border flex items-center justify-between rounded-md max-[570px]:gap-1">
      <div ref={ref} className="relative">
        <div
          onClick={() => setOpen(true)}
          className="flex items-center gap-4 px-4 py-2 cursor-pointer"
        >
          <h3 className="font-semibold max-lg:text-sm">
            {state.delivery?.[state.insideRiyadh ? 0 : 1]?.[`title_${locale}`]}
          </h3>
          <ArrowIcon
            className={`${
              open ? "-rotate-90" : "rotate-90"
            } transition-all size-3.5`}
          />
        </div>
        {open && (
          <ul className="absolute z-50 min-w-[120px] bg-white border top-full start-0">
            {state.delivery?.map((info) => (
              <li
                key={info?.descriptions_ar + info?.descriptions_en}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    insideRiyadh: info?.city === "1101",
                  }));
                  setOpen(false);
                }}
                className="font-semibold whitespace-nowrap cursor-pointer border-b hover:bg-red hover:text-white px-2 lg:px-4 py-2 max-[570px]:text-sm"
              >
                {info?.[`title_${locale}`]}
              </li>
            ))}
          </ul>
        )}
      </div>
      <p className="px-2 text-sm lg:px-4 lg:text-lg">
        {
          state.delivery?.[state.insideRiyadh ? 0 : 1]?.[
            `descriptions_${locale}`
          ]
        }
      </p>
    </div>
  );
};

export default DeliveryInformations;
